import { SupervisionComponentAPI } from "./supervision-component-api";
import { Address } from "../../../components/shared-components/class/component-classes/address";
import { AddressService } from "src/service/address.service";
import {
  AggregationType,
  GuiComponent,
} from "src/model/enum/enumCustomInterface";

export class ComponentAggregation {
  public idAggregate: string = "";
  public instanceGUID: string = "";
  public name: string = ""; //Generic property to display in supervision
  public address: Address = null; // Property to store address if idAggregate is address
  public listComponent: SupervisionComponentAPI[] = [];
  public tabOrder: number = 999;

  /**
   * Getter for aggregate-type //
   */
  get code(): AggregationType {
    return this.getAggregationType();
  }

  constructor(obj?) {
    if (obj) Object.assign(this, obj);
  }

  /**
   * Refresh aggregate tab order by input parameter
   *
   * @param newTabOrder New tab order to assign to component
   */
  public updateAggregateTabOrder(newTabOrder: number): void {
    if (this.listComponent.length > 0) {
      for (let index = 0; index < this.listComponent.length; index++) {
        this.listComponent[index].properties["TabOrder"] =
          newTabOrder.toString();
      }
      this.tabOrder = newTabOrder;
    }
  }

  /**
   * Refresh aggregate tab order by own child supervision component.
   * It takes lowest value of TabOrder child component
   */
  public refreshAggregateTabOrder(): void {
    this.tabOrder = 999;

    if (this.listComponent.length > 0) {
      this.listComponent = this.listComponent.sort((a, b) => {
        return a.properties["TabOrder"] - b.properties["TabOrder"];
      });

      this.tabOrder = parseInt(
        this.listComponent[0].properties["TabOrder"],
        10
      );
    }
  }

  /**
   * Calculate aggregate name finding AggregateLabel in inner aggregate component list.
   * If is empty, it will try to find releated aggregate address  and it will take it address name.
   * Otherwise return empty string
   */
  public calculateAggregationName(): void {
    let indexComponent = 0;
    this.name = "";

    while (indexComponent < this.listComponent.length && this.name === "") {
      const singleComponent: SupervisionComponentAPI =
        this.listComponent[indexComponent];

      this.name = singleComponent.properties["AggregateLabel"] || "";

      indexComponent++;
    }

    if (this.address && this.name === "") {
      this.name = this.address.name;
    }

    if (this.name === "") {
      this.name = this.getDefaultNameByAggregateType();
    }
  }

  /**
   * Calculate aggregate aggregation type by inner child componet
   *
   * @returns Aggregation component type
   */
  private getAggregationType(): AggregationType {
    const commandButtonCount: number = this.countInnerChildComponentByType(
      GuiComponent.COMMAND_BUTTON
    );
    const labelCount: number = this.countInnerChildComponentByType(
      GuiComponent.LABEL
    );
    const gaugeCount: number = this.countInnerChildComponentByType(
      GuiComponent.GAUGE
    );
    const vlcCameraCount: number = this.countInnerChildComponentByType(
      GuiComponent.VLC_CAMERA
    );
    const scenarioButtonCount: number = this.countInnerChildComponentByType(
      GuiComponent.SCENARIO_BUTTON
    );

    const supervisionButtonCount: number = this.countInnerChildComponentByType(
      GuiComponent.SUPERVISION_BUTTON
    );

    const imageComponent: number = this.countInnerChildComponentByType(
      GuiComponent.IMAGE
    );

    const valueChartCount: number = this.countInnerChildComponentByType(
      GuiComponent.VALUE_CHART
    );

    const virtualAccessCount: number = this.countInnerChildComponentByType(
      GuiComponent.VIRTUAL_ACCESS
    );

    const customComponentCount: number = this.countInnerChildComponentByType(
      GuiComponent.CUSTOM_COMPONENT
    );

    const sqlTableComponentCount: number = this.countInnerChildComponentByType(
      GuiComponent.SQL_TABLE
    );

    if (commandButtonCount === 2 && labelCount === 1) {
      return AggregationType.TWO_COMMAND_AND_LABEL_TEMPLATE;
    } else if (virtualAccessCount === 1) {
      return AggregationType.VIRTUAL_ACCESS_TEMPLATE;
    } else if (
      gaugeCount >= 1 ||
      vlcCameraCount >= 1 ||
      valueChartCount >= 1 ||
      imageComponent >= 1 ||
      customComponentCount >= 1
    ) {
      return AggregationType.MULTIPLE_ROWS_TEMPLATE;
    } else if (sqlTableComponentCount >= 1) {
      return AggregationType.UNKNOWN;
    } else if (
      (labelCount === 1 && this.listComponent.length === 2) ||
      (labelCount === 0 && this.listComponent.length === 1) ||
      (labelCount === 1 && this.listComponent.length === 1)
    ) {
      return AggregationType.ONE_COMMAND_TEMPLATE;
    } else if (this.listComponent.length >= 2) {
      return AggregationType.TWO_OR_MORE_COMMAND_TEMPLATE;
    } else {
      return AggregationType.UNKNOWN;
    }
  }

  /**
   * Count inner component occurrences by generic component type
   *
   * @param componentType Component type to count
   * @returns Number of component occurency
   */
  private countInnerChildComponentByType(componentType: GuiComponent): number {
    return this.listComponent.filter((comp) => comp.code === componentType)
      .length;
  }

  /**
   * Return default aggregate name by aggregate type
   *
   * @returns Defautl aggregate name when is not populated
   */
  private getDefaultNameByAggregateType(): string {
    let defaultAggregateName: string = "";

    switch (this.getAggregationType()) {
      case AggregationType.VIRTUAL_ACCESS_TEMPLATE:
        defaultAggregateName = "Tastierino virtuale";
        break;
    }

    return defaultAggregateName;
  }
}
